export function suggestProfileName(orgName, licenseAlias) {
  const name = orgName?.trim();
  const alias = licenseAlias?.trim();
  if (name && alias) return `${name} - ${alias}`;
  if (name) return `${name} Profile`;
  if (alias) return `${alias} Profile`;
  return '';
}

export function getLicenseProfileRef(organisation = {}) {
  const id = organisation.license_permission_profile_id;
  if (id === null || id === undefined || id === '') return null;
  return {
    id,
    name: organisation.license_permission_profile_name || 'License template',
  };
}
